export default __webpack_public_path__ + "static/media/redball.ad226416.png";